const containerUsers = document.querySelector('.users-table-container');

//-- DOM add user
const btnAddNewUser = document.querySelector('#add-new-user'),
      modalAddUser = document.querySelector('#modalAddUser'),
      txtUserName = document.querySelector('#addUserName'),
      txtUserPaternal = document.querySelector('#addUserPaternal'),
      txtUserMaternal = document.querySelector('#addUserMaternal'),
      txtUserEmail = document.querySelector('#addUserEmail'),
      txtUserPassword = document.querySelector('#addUserPassword'),
      selectUserRole = document.querySelector('#addUserRole'),
      btnCancelAddUser = document.querySelector('#cancelAddUserModal'),
      btnSaveAddUser = document.querySelector('#saveAddUserModal');

//-- DOM update user
const modalUpdateUser = document.querySelector('#modalUpdateUser'),
      txtUpdateUserName = document.querySelector('#updateUserName'),
      txtUpdateUserPaternal = document.querySelector('#updateUserPaternal'),
      txtUpdateUserMaternal = document.querySelector('#updateUserMaternal'),
      txtUpdateUserEmail = document.querySelector('#updateUserEmail'),
      txtUpdateUserId = document.querySelector('#updateUserId'),
      selectUpdateUserRole = document.querySelector('#updateUserRole'),
      btnCancelUpdateUser = document.querySelector('#cancelUpdateUserModal'),
      btnSaveUpdateUser = document.querySelector('#saveUpdateUserModal');

//-- DOM change password
const modalUpdatePassword = document.querySelector('#modalChangePassword'),
      btnCancelUpdatePassword = document.querySelector('#cancelChangePasswordUserModal'),
      btnUpdatePassword = document.querySelector('#changePasswordUserModal'),
      btnUpdatePasswordUserId = document.querySelector('#changePasswordUserId'),
      txtPasswordToUpdate = document.querySelector('#changePasswordUser');

//--- Paginator
let pageNumber = 1,
    pageSize= 10,
    maxPages = 0,
    currentPageSpan = document.querySelector('#currentPage'),
    allPagesSpan = document.querySelector('#allPages'),
    btnNext = document.querySelector('#btnNext'),
    btnPrev = document.querySelector('#btnPrev');


sessionStorage.removeItem('context');
document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';
var url_picture = null;

window.addEventListener("load", loadPage);
function loadPage() {
  if ((localStorage.getItem('user_type') || "") != "1") {
    UI.showLoader();
    location.href = "index.html";
  }
  else {
    loadUsers();
  }
}

//object data
let dataUsers = [];

// --- Functions
function loadUsers(){
 UI.showLoader()
 fetch(
   BASE_URLS.Dinny.api + '/users/list',
   {
     method: 'get',
     credentials: 'include'
   }
 ).then(function(response){
   if(response.ok){
     response.json().then(function(json){
      dataUsers = json
      injectUserCardsDOM(dataUsers);
     })
   }else{
     response.json().then(function(error){
       UI.message({
         title: 'Error',
         content: (error && error.message) ? error.message : 'Ocurrió un error al registra el usuario.',
         accept: 'Aceptar'
       })
       console.log(error)
     })
   }
 }).catch(function(error){
   error.json().then(function(content){
     UI.message({
       title: 'Error',
       content: (content && content.message) ? content.message : 'Ocurrió un error al registra el usuario.',
       accept: 'Aceptar'
     })
   })
   console.error(error)
 }).finally( f =>  {
   UI.hideLoader()
 })
}

function getLayoutUserCard(data){
  let role = data.role == 'restaurateur' ? 'Restaurantero' : 'Administrador',
      layout = `
        <div class="users-table-item animate__animated animate__fadeIn" data-id="${data.id}">
          <div class="w-35 text-steel-80">${data.name + ' ' + data.paternal_surname + ' ' + data.maternal_surname}</div>
          <div class="w-30 text-steel-80">${data.email}</div>
          <div class="w-20 ${data.role == 'restaurateur' ? 'text-yellow' : 'text-green'}">${role}</div>
          <div class="w-15 item-actions">
            <span class="icon-password" title="Cambiar contraseña" onclick="openModalUpdatePassword(event)"></span>
            <span class="icon-edit" title="Editar usuario" onclick="openModalEditUser(event)"></span>
            <span class="icon-trash" title="Eliminar usuario" onclick="deleteUser(event)"></span>
          </div>
        </div>
      `;
  return layout;
}

function injectUserCardsDOM(users){
  if(users.length == 0){
    UI.message({title: 'No hay usuarios registrados', content: 'Comienza a agregar usuarios.', accept: 'Aceptar'}, function(){
      modalAddUser.classList.remove('hide');
    });
    document.querySelector('.users-table-paginator').classList.add('hide');
  }
  else{
    document.querySelector('.users-table-paginator').classList.remove('hide');
    maxPages = Math.ceil(users.length / pageSize);
    if(pageNumber != maxPages){
        btnNext.disabled = false;
    }
    currentPageSpan.textContent = pageNumber;
    allPagesSpan.textContent = 'de '+ maxPages;
    users = paginate(users,pageSize,pageNumber);

    let layout=`
      <div class="users-table-head">
        <div class="users-table-head__name">NOMBRE</div>
        <div class="users-table-head__email">CORREO ELECTRÓNICO</div>
        <div class="users-table-head__role">ROL</div>
        <div class="users-table-head__actions">ACCIONES</div>
      </div>
    `;

    users.forEach(function(user){
      layout += getLayoutUserCard(user);
    });

    containerUsers.innerHTML = "";
    containerUsers.insertAdjacentHTML('beforeend', layout);
  }
}

function openModalUpdatePassword(e){
  let idUser = e.target.parentNode.parentNode.dataset.id,
      dataUser = dataUsers.filter(element => element.id == idUser)[0];

  modalUpdatePassword.classList.remove('hide');
  btnUpdatePasswordUserId.value = dataUser.id
}

function openModalEditUser(e){
  let idUser = e.target.parentNode.parentNode.dataset.id,
      dataUser = dataUsers.filter(element => element.id == idUser)[0];
  modalUpdateUser.classList.remove('hide');
  txtUpdateUserName.value = dataUser.name;
  txtUpdateUserPaternal.value = dataUser.paternal_surname;
  txtUpdateUserMaternal.value = dataUser.maternal_surname;
  txtUpdateUserEmail.value = dataUser.email;
  txtUpdateUserId.value = dataUser.id

  if(dataUser.role == 'restaurateur'){
    selectUpdateUserRole.value = 'restaurateur';
  }
  else{
    selectUpdateUserRole.value = 'admin';
  }
}

function deleteUser(e){
  let idUser = e.target.parentNode.parentNode.dataset.id,
      dataUser = dataUsers.filter(element => element.id == idUser)[0];
    UI.confirm({
        title: 'Eliminar usuario',
        content: '¿Estás seguro de eliminar este usuario?',
        cancel: 'Cancelar',
        accept: 'Aceptar'
      },function(confirm){
        if(confirm){
          UI.showLoader()
          fetch(
            BASE_URLS.Dinny.api + '/users/delete',
            {
              method: 'post',
              body: JSON.stringify({
                id: dataUser.id
              }),
              credentials: 'include'
            }
          ).then(function(response){
            if(response.ok){
              response.json().then(function(json){
                UI.message({
                  title: '',
                  content: json.message || 'El usuario ha sido eliminado.',
                  accept: 'Cerrar'
                }, function(){
                  loadPage()
                })
                injectUserCardsDOM(dataUsers);
              })
            }else{
              response.json().then(function(error){
                UI.message({
                  title: 'Error',
                  content: (error && error.message) ? error.message : 'Ocurrió un error al registra el usuario.',
                  accept: 'Aceptar'
                })
                console.log(error)
              })
            }
          }).catch(function(error){
            error.json().then(function(content){
              UI.message({
                title: 'Error',
                content: (content && content.message) ? content.message : 'Ocurrió un error al registra el usuario.',
                accept: 'Aceptar'
              })
            })
            console.error(error)
          }).finally( f =>  {
            UI.hideLoader()
          })
        }
    });
}

function paginate(array, page_size, page_number) {
  return array.slice((page_number - 1) * page_size, page_number * page_size);
}

function nextPage(){
  pageNumber ++;
  if(pageNumber == maxPages){
      btnNext.disabled = true;
  }
  btnPrev.disabled = false;
  injectUserCardsDOM(dataUsers);
}

function previusPage(){
  pageNumber --;
  if(pageNumber == 1){
      btnPrev.disabled = true;
  }
  btnNext.disabled = false;
  injectUserCardsDOM(dataUsers);
}



/// --- Event listeners
//Add user
btnAddNewUser.addEventListener('click', function(e){
  e.preventDefault()
  modalAddUser.classList.remove('hide');
});

btnCancelAddUser.addEventListener('click', function(){
  modalAddUser.classList.add('hide');
  txtUserName.value = "";
  txtUserMaternal.value = "";
  txtUserPaternal.value = "";
  txtUserEmail.value = "";
  txtUserPassword.value = "";
  selectUserRole.value = "";
});

function validateUserData(data, isSingUp) {
  isSingUp = isSingUp == undefined
  let errors = []
  if (data.txtUserName.value.length >= 3 && data.txtUserName.value.length <= 150) {
    if (!/^[a-záéíóúäëïöüñÁÉÍÓÚÄËÏÖÜÑ ]{3,150}$/ig.test(data.txtUserName.value)) {
      errors.push('El nombre no es válido.')
    }
  } else {
    errors.push('El nombre debe tener entre 3 y 150 caracteres de longitud.')
  }

  if (data.txtUserPaternal.value.length >= 3 && data.txtUserPaternal.value.length <= 150) {
    if (!/^[a-záéíóúäëïöüñÁÉÍÓÚÄËÏÖÜÑ ]{3,150}$/ig.test(data.txtUserPaternal.value)) {
      errors.push('El apellido paterno no es válido.')
    }
  } else {
    errors.push('El apellido paterno debe tener entre 3 y 150 caracteres de longitud. ')
  }

  if (data.txtUserMaternal.value.length >= 3 && data.txtUserMaternal.value.length <= 150) {
    if (!/^[a-záéíóúäëïöüñÁÉÍÓÚÄËÏÖÜÑ ]{3,150}$/ig.test(data.txtUserMaternal.value)) {
      errors.push('El apellido materno no es válido.')
    }
  } else {
    errors.push('El apellido materno debe tener entre 3 y 150 caracteres de longitud.')
  }
  if (data.txtUserEmail.value.length >= 1 && data.txtUserEmail.value.length <= 255) {
    if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ig.test(data.txtUserEmail.value)) {
      errors.push('El correo electrónico no es válido.')
    }
  } else {
    errors.push('El correo electrónico es obligatorio.')
  }

  if (data.ddlUserRole.value.length == 0) {
    errors.push('El rol del usuario es obligatorio.');
  }

  if (isSingUp) {
    const passwordValidation = validatePassword(data)
    if (passwordValidation) {
      errors.push(passwordValidation)
    }
  }
  return errors
}

function validatePassword(data){
  if(data.txtUserPassword.value.length >= 8){
    if(/[a-z]/g.test(data.txtUserPassword.value)){
      if(/[A-Z]/g.test(data.txtUserPassword.value)){
        if(/[0-9]/g.test(data.txtUserPassword.value)){
          if(/[^a-zA-Z\d]/g.test(data.txtUserPassword.value)){
            let arrayString = Array.from(data.txtUserPassword.value)
            let consecutiveNumbers = null
            let hasConsecutive = false
            do{
              consecutiveNumbers = [...arrayString.join('').matchAll(/[0-9]{2}/g)]
              if(consecutiveNumbers.length > 0){
                for (let index = 0; index < consecutiveNumbers.length; index++) {
                  const e = consecutiveNumbers[index];
                  const A = parseInt(e[0][0]), B = parseInt(e[0][1])
                  if(A == B+1 || A+1 == B){
                    if(!hasConsecutive){
                      console.log('Encontró números consecutivos.')
                      return 'La contraseña no puede tener números consecutivos.'
                    }
                  }
                }
                // consecutiveNumbers.forEach(e => {
                // })
              }
              arrayString.shift()
            }while(arrayString.length > 2)
          }else{
            return 'La contraseña debe tener por lo menos un carácter especial.'
          }
        }else{
          return 'La contraseña debe tener por lo menos un número.'
        }
      }else{
        return 'La contraseña debe tener por lo menos una letra mayúscula.'
      }
    }else{
      return 'La contraseña debe tener por lo menos una letra minúscula.'
    }
  }else{
    return 'La contraseña debe tener mínimo 8 caracteres. Agrega al menos una mayúscula, una minúscula, un carácter especial y un número.'
  }
}

btnSaveAddUser.addEventListener('click', function () {
  let errors = validateUserData({
    txtUserName: txtUserName,
    txtUserPaternal: txtUserPaternal,
    txtUserMaternal: txtUserMaternal,
    txtUserEmail: txtUserEmail,
    txtUserPassword: txtUserPassword,
    ddlUserRole: selectUserRole
  })


  if (errors.length == 0) {
    UI.showLoader()
    const now = new Date()
    const day = now.getDate(), month = (now.getMonth() + 1).toString().length == 1 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1), year = now.getFullYear() - 16
    const body = {
      email: txtUserEmail.value,
      phone_number: '0000000000',
      name: txtUserName.value,
      paternal_surname: txtUserPaternal.value,
      maternal_surname: txtUserMaternal.value,
      password: txtUserPassword.value,
      role: selectUserRole.value,
      birth_date: `01/${month}/${year}`
    }
    fetch(
      BASE_URLS.Dinny.api + '/users/add',
      {
        method: 'post',
        body: JSON.stringify(body),
        credentials: 'include'
      }
    ).then(function (response) {
      console.log(response);
      if (response.ok) {
        UI.message({
          title: '',
          content: 'El usuario ha sido registrado con éxito.',
          accept: 'Aceptar'
        }, function () {
          modalAddUser.classList.add('hide');
          txtUserName.value = "";
          txtUserMaternal.value = "";
          txtUserPaternal.value = "";
          txtUserEmail.value = "";
          txtUserPassword.value = "";
          selectUserRole.value = "";
          loadPage()
        })
      } else {
        response.json().then(function (error) {
          UI.message({
            title: 'Error',
            content: (error && error.message) ? error.message : 'Ocurrió un error al registra el usuario.',
            accept: 'Aceptar'
          })
          console.log(error)
        })
      }
    }).catch(function (error) {
      console.log(error);
      error.json().then(function (content) {
        UI.message({
          title: 'Error',
          content: (content && content.message) ? content.message : 'Ocurrió un error al registra el usuario.',
          accept: 'Aceptar'
        })
      })
      console.error(error)
    }).finally(f => {
      UI.hideLoader()
    })
  } else {
    let errorsRegister = `<ul class="mt-0">${errors.map(e => '<li>' + e + '</li>').join(' ')}</ul>`;
    UI.messageList({
      title: 'Datos incorrectos',
      content: errorsRegister,
      accept: 'Aceptar'
    })
  }
});

//-- Update user
btnCancelUpdateUser.addEventListener('click', function(){
  modalUpdateUser.classList.add('hide');
  txtUpdateUserName.value = "";
  txtUpdateUserMaternal.value = "";
  txtUpdateUserPaternal.value = "";
  txtUpdateUserEmail.value = "";
  selectUpdateUserRole.value = "";
});

btnSaveUpdateUser.addEventListener('click', function(){
  let errors = validateUserData({
    txtUserName: txtUpdateUserName,
    txtUserPaternal:txtUpdateUserPaternal,
    txtUserMaternal:txtUpdateUserMaternal,
    txtUserEmail:txtUpdateUserEmail,
    ddlUserRole: selectUpdateUserRole
  }, false)
  if(errors.length == 0){
    const body = {
      id: txtUpdateUserId.value,
      email: txtUpdateUserEmail.value,
      name: txtUpdateUserName.value,
      paternal_surname: txtUpdateUserPaternal.value,
      maternal_surname: txtUpdateUserMaternal.value,
      role: selectUpdateUserRole.value,
    }
    fetch(
      BASE_URLS.Dinny.api + '/users/update',
      {
        method: 'post',
        body: JSON.stringify(body),
        credentials: 'include'
      }
    )
    .then(function(response){
      if(response.ok){
        modalUpdateUser.classList.add('hide');
        UI.message({
          title: '',
          content: 'Los datos del usuario han sido actualizados con éxito.',
          accept: 'Aceptar'
        }, function(){
          modalAddUser.classList.add('hide');
          loadPage()
        })
      }else{
        response.json().then(function(error){
          UI.message({
            title: 'Error',
            content: (error && error.message) ? error.message : 'Ocurrió un error al actualizar los datos del usuario.',
            accept: 'Aceptar'
          })
          console.log(error)
        })
      }
    }).catch(function(error){
      error.json().then(function(content){
        UI.message({
          title: 'Error',
          content: (content && content.message) ? content.message : 'Ocurrió un error al actualizar los datos.',
          accept: 'Aceptar'
        })
      })
      console.error(error)
    }).finally( f =>  {
      UI.hideLoader()
    })
  }else{
    UI.message({
      title:'Datos incorrectos',
      content: `<ul>${errors.map(e => '<li>' + e + '</li>').join(' ')}</ul>`,
      accept: 'Aceptar'
    })
  }
});

//-- Update password
btnCancelUpdatePassword.addEventListener('click', function(){
  modalUpdatePassword.classList.add('hide');
  txtPasswordToUpdate.value = "";
});

btnUpdatePassword.addEventListener('click', function(){
  const passwordValidation = validatePassword({
    txtUserPassword: txtPasswordToUpdate
  })
  if(passwordValidation){
    UI.message({
      title: 'Datos incorrectos',
      content: passwordValidation,
      accept: 'Aceptar'
    })
  }else{
    UI.showLoader()
    fetch(
      BASE_URLS.Dinny.api + '/users/change_password',
      {
        method: 'post',
        body: JSON.stringify({
          "id": btnUpdatePasswordUserId.value,
          "password": txtPasswordToUpdate.value
        }),
        credentials: 'include'
      }
    ).then(function(response){
      if(response.ok){
        UI.message({
          title: '',
          content: 'La contraseña ha sido actualizada con éxito.',
          accept: 'Aceptar'
        }, function(){
          modalUpdatePassword.classList.add('hide');
          loadPage()
        })
      }else{
        response.json().then(function(error){
          UI.message({
            title: 'Error',
            content: (error && error.message) ? error.message : 'Ocurrió un error al actualizar la contraseña.',
            accept: 'Aceptar'
          })
          console.log(error)
        })
      }
    }).catch(function(error){
      error.json().then(function(content){
        UI.message({
          title: 'Error',
          content: (content && content.message) ? content.message : 'Ocurrió un error al cambiar la contraseña.',
          accept: 'Aceptar'
        })
      })
      console.error(error)
    }).finally( f =>  {
      UI.hideLoader()
    })
  }
});


//-- Paginator
btnPrev.addEventListener("click", previusPage);
btnNext.addEventListener("click", nextPage);